export default __webpack_public_path__ + "assets/4.70fbf20d.png";